import React, { Fragment, useState, useEffect, memo, useContext } from "react";
import axios from "axios";
import { variables } from "../../Variables";
import theme from "../UI/Theme";
import Deposits from "../Deposits";
import { SocketContext } from "../../utils/socket-client";
import { SyncLoader } from "react-spinners";

// MUI IMPORTS
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import Box from "@mui/material/Box";

const PaymentsIn = (props) => {
  const { tabInitialDate, tabFinalDate, showBank, updatePayment, refresh, showBankHandler, MainContentReport } = props;
  
  const mySocket = useContext(SocketContext);
  const [socket, setSocket] = useState(null);

  const [paymentsByDateList, setPaymentsByDateList] = useState([]);
  const [paymentsUnallocatedByDateList, setPaymentsUnallocatedByDateList] = useState([]);
  const [paymentsByTypeByDateList, setPaymentsByTypeByDateList] = useState([]);
  const [paymentsUnallocatedByTypeByDateList, setPaymentsUnallocatedByTypeByDateList] = useState([]);

  const [totalStandardPaymentsByDate, setTotalStandardPaymentsByDate] = useState(0);
  const [totalPaymentsUnallocatedByDate, setTotalPaymentsUnallocatedByDate] = useState(0);

  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [isLoading3, setIsLoading3] = useState(false);
  const [isLoading4, setIsLoading4] = useState(false);

  const [showDetails, setShowDetails] = useState(false);
  // Cambiamos el estado a un booleano simple para refresco por socket
  const [needsRefresh, setNeedsRefresh] = useState(false);

  const showDetailsHandler = () => setShowDetails((prev) => !prev);

  // --- API CALLS ---
  const fetchData = () => {
    if (!tabInitialDate || !tabFinalDate) return;

    setIsLoading1(true);
    setIsLoading2(true);
    setIsLoading3(true);
    setIsLoading4(true);

    // 1. Standard Payments
    axios.get(`${variables.API_URL}/payments/paymentsbydate/${tabInitialDate}/${tabFinalDate}/${showBank}`, { withCredentials: true })
      .then((res) => {
        const data = res.data.paymentsByDate || [];
        setPaymentsByDateList(data);
        setTotalStandardPaymentsByDate(data.length > 0 ? data.slice(-1)[0].cumulative_sum : 0);
        setIsLoading1(false);
      }).catch(err => { console.error(err); setIsLoading1(false); });

    // 2. Unallocated Payments
    axios.get(`${variables.API_URL}/payments/paymentsbydateunallocated/${tabInitialDate}/${tabFinalDate}/${showBank}`, { withCredentials: true })
      .then((res) => {
        const data = res.data.paymentsByDateUnallocated || [];
        setPaymentsUnallocatedByDateList(data);
        setTotalPaymentsUnallocatedByDate(data.length > 0 ? data.slice(-1)[0].cumulative_sum : 0);
        setIsLoading2(false);
      }).catch(err => { console.error(err); setIsLoading2(false); });

    // 3. By Type
    axios.get(`${variables.API_URL}/payments/paymentsbytypebydate/${tabInitialDate}/${tabFinalDate}/${showBank}`, { withCredentials: true })
      .then((res) => {
        setPaymentsByTypeByDateList(res.data.paymentsByTypeByDate || []);
        setIsLoading3(false);
      }).catch(err => { console.error(err); setIsLoading3(false); });

    // 4. Unallocated By Type
    axios.get(`${variables.API_URL}/payments/paymentsbytypebydateunallocated/${tabInitialDate}/${tabFinalDate}`, { withCredentials: true })
      .then((res) => {
        setPaymentsUnallocatedByTypeByDateList(res.data.paymentsByTypeByDateUnallocated || []);
        setIsLoading4(false);
      }).catch(err => { console.error(err); setIsLoading4(false); });
  };

  // --- EFECTO PRINCIPAL: Carga por fechas o cambios de estado ---
  useEffect(() => {
    fetchData();
  }, [tabInitialDate, tabFinalDate, showBank, updatePayment, refresh, needsRefresh]);

  // --- SOCKET LOGIC ---
  useEffect(() => {
    setSocket(mySocket);
  }, [mySocket]);

  useEffect(() => {
    if (!socket) return;
    socket.on("getNotification", (data) => {
      if (data.type.notificationType === 1) {
        // En lugar de Math.random(), simplemente invertimos el booleano
        setNeedsRefresh(prev => !prev);
      }
    });
    return () => socket.off("getNotification");
  }, [socket]);

  const isLoading = isLoading1 || isLoading2 || isLoading3 || isLoading4;

  return (
    <Fragment>
      {!isLoading ? (
        <Deposits
          title="Payments In"
          selectedDatesFromInitial={tabInitialDate}
          selectedDatesTo={tabFinalDate}
          paymentsInByDateList={paymentsByDateList}
          paymentsUnallocatedByDateList={paymentsUnallocatedByDateList}
          totalPaymentsByDate={totalStandardPaymentsByDate + totalPaymentsUnallocatedByDate}
          totalStandardPaymentsByDate={totalStandardPaymentsByDate}
          totalPaymentsUnallocatedByDate={totalPaymentsUnallocatedByDate}
          paymentsByTypeByDateList={paymentsByTypeByDateList}
          paymentsUnallocatedByTypeByDateList={paymentsUnallocatedByTypeByDateList}
          showDetails={showDetails}
          showDetailsHandler={showDetailsHandler}
          showBankHandler={showBankHandler}
          MainContentReport={MainContentReport}
          icon={<CreditScoreIcon sx={{ fontSize: 20, color: "#4E1721", marginRight: 2, mt: -1 }} />}
          showBank={showBank}
        />
      ) : (
        <Box textAlign="center" sx={{ py: 2 }}>
          <SyncLoader color="#7A1125" size={15} />
        </Box>
      )}
    </Fragment>
  );
};

// Evita re-renders si el padre cambia pero las fechas siguen siendo las mismas
export default memo(PaymentsIn, (prev, next) => {
  return (
    prev.tabInitialDate === next.tabInitialDate &&
    prev.tabFinalDate === next.tabFinalDate &&
    prev.showBank === next.showBank &&
    prev.refresh === next.refresh &&
    prev.updatePayment === next.updatePayment
  );
});